import React from 'react';
import { Body, Box, BoxProps, Icon } from '@hover/blueprint';
import { iUsers } from '@hover/icons';
import NewsLetterLink from './NewsLetterLink';

interface Props extends BoxProps {
  iconColor: string;
}

const NewsLetterViewJobs: React.FC<Props> = ({ iconColor, ...restProps }) => (
  <Box
    alignItems="start"
    flex={1}
    w={{ base: '100%', desktop: '200px' }}
    flexDir="column"
    justifyContent="space-between"
    mb={{ base: 700, tablet: 0 }}
    {...restProps}
  >
    <Icon m={0} icon={iUsers} color={iconColor} size="large" />
    <Body color="neutral.0" size={500} isBold pt={500} pb={400}>
      LIKE WHAT YOU READ? JOIN OUR TEAM
    </Body>
    <Body maxW="90%" color="neutral.0" size={500} pb={500}>
      HOVER uses the best 3D property data to help people improve their homes.
    </Body>
    <NewsLetterLink
      to={`${process.env.GATSBY_V2_PREFIX}/careers#open-roles`}
      title="View jobs"
    />
  </Box>
);

export default NewsLetterViewJobs;
